// extracted by mini-css-extract-plugin
export default {"dataConstitution":"styles_dataConstitution__Gq74S","titlesWrapper":"styles_titlesWrapper__gaczd","dataItemsWrapper":"styles_dataItemsWrapper__A9CLh"};